import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import moment from 'moment';
import axios from 'axios';
import VueMeta from 'vue-meta';
import vco from 'v-click-outside';
import App from './App.vue';
import router from './router/index';

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(moment);
Vue.use(vco);
// Vue.use(axios);

Vue.use(VueMeta, {
	// optional pluginOptions
	refreshOnceOnNavigation: true,
});

Vue.prototype.$moment = moment;
Vue.prototype.$http = axios;

new Vue({
	render: h => h(App),
	router,
}).$mount('#app');
